export const keyVal = (val: string | number, i?: number) => `${val}-${i ?? ''}`;
